import React from "react";

const SwitchDesconocido = ({ prendido, onCambio, label = "Se desconoce" }) => {
  return (
    <label style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
      <span style={{ fontSize: "12px", color: "#6b7280" }}>{label}</span>
      <label className="switch">
        <input
          type="checkbox"
          checked={!!prendido}
          onChange={(e) => onCambio(e.target.checked)}
        />
        <span className="slider"></span>
      </label>
    </label>
  );
};

export default SwitchDesconocido;